import React from 'react';

import { useTranslation } from 'react-i18next';
import type { TemplateSection } from 'inspection-types';

import { formatSectionTitle } from '../../helpers/inspectionTemplateCustomizeHelpers';

import styles from './InspectionTemplateCustomizeSidebar.scss';

function scrollToTemplateSection(sectionId: string): void {
  const el = document.getElementById(`section-${sectionId}`);

  el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

type Props = {
  sections: TemplateSection[];
  activeSectionId: string | null;
};

export function InspectionTemplateCustomizeSidebar({
  sections,
  activeSectionId,
}: Props) {
  const { t } = useTranslation();

  return (
    <aside
      className={styles.sidebar}
      aria-label={t(
        'web.admin.inspections.templateCustomize.sectionsNavLabel'
      )}
    >
      <div className={styles.sidebarTitle}>
        {t('web.admin.inspections.templateCustomize.sectionsSidebarTitle')}
      </div>
      <nav className={styles.sidebarNav}>
        {sections.map((section, sectionIndex) => (
          <button
            key={section.id}
            type="button"
            className={`${styles.sidebarButton} ${
              activeSectionId === section.id ? styles.sidebarButtonActive : ''
            }`}
            onClick={() => scrollToTemplateSection(section.id)}
          >
            {formatSectionTitle(sectionIndex, section.name)}
          </button>
        ))}
      </nav>
    </aside>
  );
}
